"use client";

import { useRef } from "react";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGalleryOfDigitalExcellence() {
  const projects = [{
    id: 1,
    name: "Vanguard Aesthetics",
    year: 2024,
    industry: "SOCIAL CONTENT",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/vanguard_aesthetics_reel.png",
    colSpan: 2
  }, {
    id: 2,
    name: "Neon Pulse",
    year: 2023,
    industry: "STREAM ASSETS",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/neon_pulse_stream.png",
    colSpan: 1
  }, {
    id: 3,
    name: "Obsidian Flow",
    year: 2024,
    industry: "BRAND FILM",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/obsidian_flow_brand.png",
    colSpan: 1
  }, {
    id: 4,
    name: "Kinetic Theory",
    year: 2023,
    industry: "SOCIAL CONTENT",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/kinetic_theory_social.png",
    colSpan: 1
  }, {
    id: 5,
    name: "Ethereal Motion",
    year: 2024,
    industry: "CINEMATIC",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/ethereal_motion_cinematic.png",
    colSpan: 2
  }, {
    id: 6,
    name: "Digital Horizon",
    year: 2023,
    industry: "COMMERCIAL",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/digital_horizon_commercial.png",
    colSpan: 1
  }];
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    ref: galleryRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="237206" id="the-master-reel" className="bg-background text-foreground py-20 px-4 sm:px-6 lg:px-8" ref={containerRef}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <h1 className="font-default text-4xl sm:text-5xl font-extrabold mb-4 tracking-tighter leading-none uppercase">
            The Master Reel
          </h1>
          <p className="font-default text-lg text-muted-foreground max-w-2xl mx-auto">
            High-quality, cinematic artistry for brands that demand attention and absolute precision.
          </p>
        </div>

        <div ref={galleryRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 auto-rows-max">
          {projects.map((project, i) => <div key={project.id} data-index={i} className={`${project.colSpan === 2 ? "lg:col-span-2" : "lg:col-span-1"} ${isVisible ? "opacity-100" : "opacity-0"} transition-opacity duration-500`}>
              <Card className="overflow-hidden bg-card border border-border h-full rounded-none">
                <div className="relative overflow-hidden">
                  <AspectRatio ratio={16 / 9}>
                    <img src={project.image} alt={project.name} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700 hover:scale-105" />
                  </AspectRatio>

                  <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-500" />

                  <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-2 hover:translate-y-0 transition-transform duration-500 opacity-0 hover:opacity-100">
                    <Badge variant="secondary" className="bg-primary text-primary-foreground border-none rounded-none font-mono text-[10px] tracking-widest">
                      {project.industry}
                    </Badge>
                  </div>
                </div>

                <div className="p-6">
                  <h2 className="font-default text-xl font-semibold mb-2 uppercase tracking-tight">
                    {project.name}
                  </h2>
                  <p className="font-mono text-xs text-muted-foreground">
                    [{project.year}]
                  </p>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}